import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class WifiIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <circle cx="8" cy="12.5" r="1.5"/>
      <path d="M13.6,7.5A7.53,7.53,0,0,0,8,5,7.3,7.3,0,0,0,2.5,7.5L1,6.1a9.45,9.45,0,0,1,13.35-.65c.23.21.44.42.65.65Z"/>
      <path d="M10.7,10.3A3.39,3.39,0,0,0,8,9a3.18,3.18,0,0,0-2.6,1.3L3.8,9A5.46,5.46,0,0,1,8,7a5.29,5.29,0,0,1,4.2,2Z"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}


